export default __webpack_public_path__ + "static/media/port4.97aebfb4.JPG";